import Isotope from "isotope-layout";

class Filter {
  constructor() {
    this.ajaxurl = siteVars.ajaxUrl;
    this.current_page = siteVars.current_page;
    this.max_page = siteVars.max_page;
    this.query_vars = siteVars.query_vars;
    this.current_category = null; // Categoria attualmente selezionata

    this.initIsotope();
    this.initFilters();
    this.loadMore();
    this.infinite();
  }

  initIsotope() {
    // Seleziona il contenitore della griglia
    this.grid = document.querySelector(".post-grid-layout");

    if (this.grid) {
      this.iso = new Isotope(this.grid, {
        itemSelector: ".grid-item",
        layoutMode: "masonry",
        percentPosition: true,
      });
    }
  }

  initFilters() {
    const filterButtons = document.querySelectorAll(".filter-button"); // Seleziona tutti i pulsanti

    if (filterButtons.length > 0) {
      filterButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();

          const filterValue = event.target.getAttribute("data-filter"); // Ottieni il filtro selezionato
          
          // Estrai il nome della categoria dal filtro (rimuove ".cat-" dal data-filter)
          const previousCategory = this.current_category;
          if (filterValue === "*") {
            this.current_category = null; // Mostra tutto
          } else if (filterValue.startsWith(".cat-")) {
            this.current_category = filterValue.replace(".cat-", ""); // Estrae il slug della categoria
          }

          // Se la categoria è cambiata, resetta la paginazione
          if (previousCategory !== this.current_category) {
            this.current_page = siteVars.current_page; // Reset alla pagina iniziale
          }

          this.iso.arrange({ filter: filterValue }); // Applica il filtro

          // Rimuovi la classe attiva da tutti i bottoni e aggiungila al selezionato
          filterButtons.forEach((btn) => btn.classList.remove("active"));
          event.target.classList.add("active");
        });
      });
    }
  }

  loadPosts() {
    return new Promise((resolve, reject) => {

      let current_page = this.current_page;      

      const spinner = document.querySelector(".tst-spinner-loader");
      if (spinner) {
        spinner.classList.remove("d-none");
      }

      const data = new FormData();
      data.append("action", "get_ajax_posts");
      data.append("query", this.query_vars);
      data.append("page", current_page);
      
      // Aggiungi la categoria se selezionata
      if (this.current_category) {
        data.append("category", this.current_category);
      }

      fetch(this.ajaxurl, {
        method: "POST",
        body: data,
      })
        .then((response) => response.text())
        .then((response) => {
          if (response !== "") {
            const postsContainer = document.querySelector(".post-grid-layout");
            if (postsContainer) {
              const parser = new DOMParser().parseFromString(
                response,
                "text/html"
              );
              const elements = Array.from(parser.getElementsByClassName("grid-item"));

              if (this.iso) {
                this.iso.insert(elements);
                this.iso.layout();
              } else {
                for (let i = 0; i < elements.length; i++) {
                  postsContainer.appendChild(elements[i]);
                }
              }

              const itemAdded = Array.from(
                document.querySelectorAll(".grid-item")
              );
              itemAdded.forEach((item, index) => {
                setTimeout(() => {
                  itemAdded[index].className += " is-visible";
                }, 100 * index);
              });

              // Incrementa la pagina corrente
              current_page++;
              this.current_page = current_page; // Aggiorna la variabile globale
              
            }
          } else {
            const button = document.querySelector(".load-more-posts");
            if (button) button.remove();
          }

          if (spinner) {
            spinner.classList.add("d-none");
          }

          resolve(); // Risolve la Promise dopo il completamento
        })
        .catch((error) => {
          console.error("Errore durante la richiesta:", error);
          if (spinner) {
            spinner.classList.add("d-none");
          }
          reject(error); // Rifiuta la Promise in caso di errore
        });
    });
  }

  loadMore() {
    if (siteVars.pagination !== "load-more") return;

    const button = document.querySelector(".load-more-posts");
    if (!button) return;

    button.addEventListener("click", (evt) => {
      evt.preventDefault();
      this.loadPosts()
        .then(() => {
          if (this.current_page == this.max_page) {
            const button = document.querySelector(".load-more-posts");
            if (button) button.remove();
          }
      }).catch((error) => {
        console.error("Errore durante il caricamento dei post:", error);
      });
    });
  }

  infinite() {
    if (siteVars.pagination !== "infinite") return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadPosts()
            .then(() => {
              if (this.current_page == this.max_page) {
                const sentinel = document.querySelector(".infinite-sentinel");
                if (sentinel) sentinel.remove(); // Rimuovi il sentinel se non ci sono più pagine
              }else {
                observer.observe(entry.target); // Riattiva l'osservazione dopo il caricamento
              }
            })
            .catch((error) => {
              console.error("Errore durante il caricamento infinito:", error);
            });
          observer.unobserve(entry.target);
        }
      });
    });

    const sentinel = document.querySelector(".infinite-sentinel");
    if (sentinel) {
      observer.observe(sentinel);
    }
  }

}

export default Filter;
